import gate from "../gate";
import {
  exploreMethodBySlug,
  NewExploreCoursesResponse,
  NewExploreInstructorsResponse,
  NewExploreLandingsResponse,
  NewExplorePayload,
} from "types/api/new-explore";
import clientV2 from "@https/api-v2";
import client from "@https/api";
import { ExploreCategory } from "@modules/layout/modal/explore/category";

const newExploreApi = {
  [exploreMethodBySlug.course]: (params?: NewExplorePayload) =>
    gate.get<NewExploreCoursesResponse, never, NewExplorePayload>({
      client: clientV2,
      url: "explore/product/search",
      params,
    }),
  [exploreMethodBySlug.instructor]: (params?: NewExplorePayload) =>
    gate.get<NewExploreInstructorsResponse, never, NewExplorePayload>({
      client: clientV2,
      url: "explore/instructor/search",
      params,
    }),
  [exploreMethodBySlug.landing]: (params?: NewExplorePayload) =>
    gate.get<NewExploreLandingsResponse, never, NewExplorePayload>({
      client: clientV2,
      url: "explore/landing/search",
      params,
    }),

  getCategory: () =>
    gate.get<{ data: ExploreCategory[] }, never, never>({
      client: client,
      url: "product/category",
    }),

  getInstructor: (ids: string) =>
    gate.get<
      { name: string; persian_name: string; id: string }[],
      never,
      { ids: string }
    >({
      client: client,
      url: "instructors/list",
      params: { ids },
    }),
};

export default newExploreApi;
